/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: SDC PERFORMANCE™️ (https://sketchfab.com/3Duae)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/free-dodge-challenger-srt-38a1fd572beb433fa2d26d8c1070c8fa
title: ( FREE ) Dodge Challenger SRT
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { Vector3 } from "three";
import { useFrame } from "@react-three/fiber";
import useKeyboard from "../hooks/useKeyboardControls";

let rotateAngle;
let rotateVector = new Vector3(0, 1, 0);

export function Car(props) {
  const { nodes, materials } = useGLTF(
    "/assets/free__dodge_challenger_srt.glb"
  );
  const ref = useRef();
  const { forward, backward, left, right } = useKeyboard();
  useFrame((_, delta) => {
    rotateAngle = (Math.PI / 2) * delta;

    if (forward) {
      ref.current.translateZ(2 * delta);
    }
    if (backward) {
      ref.current.translateZ(-2 * delta);
    }
    if (left) {
      ref.current.rotateOnAxis(rotateVector, rotateAngle);
    }
    if (right) {
      ref.current.rotateOnAxis(rotateVector, -rotateAngle);
    }
  });

  return (
    <group {...props} dispose={null} ref={ref}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group position={[0, 0.52, 2.24]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_4.geometry}
              material={materials.Metal}
            />
          </group>
          <group position={[0, 0.31, 0.03]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_6.geometry}
              material={materials.Black}
            />
          </group>
          <group position={[0, 0.96, -0.23]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_8.geometry}
              material={materials.Chrom}
            />
          </group>
          <group position={[0, 0.71, -2.35]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_10.geometry}
              material={materials["Material.004"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_11.geometry}
              material={materials["Material.015"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_12.geometry}
              material={materials["Material.006"]}
            />
          </group>
          <group position={[0, 0.42, -0.01]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_14.geometry}
              material={materials.Carbon}
            />
          </group>
          <group position={[0, 1, -0.26]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_16.geometry}
              material={materials["Material.001"]}
            />
          </group>
          <group position={[0, 0.68, 0]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_18.geometry}
              material={materials.Carosserie}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_20.geometry}
              material={materials.Chrom}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_19.geometry}
              material={materials.Carbon}
            />
          </group>
          <group position={[0, 0.45, 2.06]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_22.geometry}
              material={materials.Black_metal}
            />
          </group>
          <group position={[0, 0.96, -0.23]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_24.geometry}
              material={materials.Chrom}
            />
          </group>
          <group position={[0, 0.31, 0.03]} rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_26.geometry}
              material={materials.Black}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_27.geometry}
              material={materials.Chrom}
            />
          </group>
          <group position={[0, 0, -0.04]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_29.geometry}
              material={materials.Glace}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_30.geometry}
              material={materials.Chrom}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_31.geometry}
              material={materials["Material.003"]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_32.geometry}
              material={materials.Light_RED}
            />
          </group>
          <group position={[0, 0, -0.04]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_34.geometry}
              material={materials["Material.002"]}
            />
          </group>
          <group position={[0, 2.35, 0]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_36.geometry}
              material={materials.Carosserie}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_37.geometry}
              material={materials.Miror}
            />
          </group>
          <group position={[0, 0, -0.04]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Object_39.geometry}
              material={materials.Carbon}
            />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_41.geometry}
            material={materials.RIMS_BLACK}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_43.geometry}
            material={materials["Material.012"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_44.geometry}
            material={materials["plaquette_de_frein.001"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_45.geometry}
            material={materials["visse.001"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_46.geometry}
            material={materials["Material.009"]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_47.geometry}
            material={materials.Material}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Object_42.geometry}
            material={materials.Tire}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/assets/free__dodge_challenger_srt.glb");
